import { UiIcon } from '../../table/models/input/ui-icon';

export class PagingConfiguration {
    actionIfNoLink: 'hide' | 'disabled';
    prevLinkElement: UiIcon;
    nextLinkElement: UiIcon;
    separatorCurTotalPage: string;      // eg: page 1/3 => "/"
    separatorRange: string;             // eg: 101/200 => "/"
    pagingEnabled: boolean;             // eg. To show : 1/3
    rangeEnabled: boolean;              // eg. To show : 101/200 (is showing 101nth items to 200nth item)


    constructor() {
        this.prevLinkElement = null;
        this.nextLinkElement = null;
        this.separatorCurTotalPage = '/';
        this.separatorRange = '-';
        this.actionIfNoLink = 'disabled';
        this.pagingEnabled = true;
        this.rangeEnabled = false;
    }
}
